import type { AxiosResponse } from 'axios';

import { APP_NAME } from 'src/constants';
import { api } from 'src/utils/axios';
import type { LogEntry } from './types';

class LogsApi {
  sendBatch(batch: LogEntry[]): Promise<AxiosResponse<unknown>> {
    return api.post('/logsBatch', batch, { params: { app_name: APP_NAME } });
  }
}

export const logsApi = new LogsApi();
